import React, {
  createContext,
  useContext,
  useReducer,
  useCallback,
} from "react";

// Initial reducer for managing form data and metadata separately
const formReducer = (state, { type, formKey, name, value, formData }) => {
  switch (type) {
    case "UPDATE_FIELD":
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: { ...state[formKey]?.data, [name]: value }, // Store form data under 'data'
          dirty: true, // Track dirty separately
        },
      };
    case "RESET_FORM":
      return {
        ...state,
        [formKey]: {
          data: { ...formData }, // Only form fields here
          dirty: false, // Separate dirty flag
        },
      };
    case "SET_DIRTY":
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          dirty: value, // Update dirty flag without affecting form data
        },
      };
    default:
      return state;
  }
};

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [forms, dispatch] = useReducer(formReducer, {});

  const updateField = useCallback((formKey, name, value) => {
    dispatch({ type: "UPDATE_FIELD", formKey, name, value });
  }, []);

  const resetForm = useCallback((formKey, formData) => {
    dispatch({ type: "RESET_FORM", formKey, formData });
  }, []);

  const setDirty = useCallback((formKey, value) => {
    dispatch({ type: "SET_DIRTY", formKey, value });
  }, []);

  return (
    <FormContext.Provider value={{ forms, updateField, resetForm, setDirty }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
